<template>
    <div class="board_search_v2 board_search_wrap">
        <ul>
            <li v-if="props.sns">
                <span class="bo_sch_tit">SNS</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allSns" @change="toggleAll(1)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.sns">
                        <input type="checkbox" v-model="select.sns" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.type">
                <span class="bo_sch_tit">검색유형</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allType" @change="toggleAll(2)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.type">
                        <input type="checkbox" v-model="select.type" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.resultType">
                <span class="bo_sch_tit">유형</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allResultType" @change="toggleAll(3)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.resultType">
                        <input type="checkbox" v-model="select.resultType" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.resultDetailType">
                <span class="bo_sch_tit">세부유형</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allDetailType" @change="toggleAll(4)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.resultDetailType">
                        <input type="checkbox" v-model="select.resultDetailType" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.nation">
                <span class="bo_sch_tit">국적</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allNation" @change="toggleAll(5)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.nation" :value="item.idx">
                        <input type="checkbox" v-model="select.nation" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.isMonitoring">
                <span class="bo_sch_tit">모니터링 이력</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" :checked="state.allIsMonitoring" @change="toggleAll(6)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.isMonitoring">
                        <input type="checkbox" v-model="select.isMonitoring" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.platform">
                <span class="bo_sch_tit">플랫폼</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allPlatform" @change="toggleAll(7)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.platform">
                        <input type="checkbox" v-model="select.platform" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.aiState">
                <span class="bo_sch_tit">판단여부</span>
                <div class="bo_sch_content">
                    <label class="chk">
                        <input type="checkbox" v-model="state.allAiState" @change="toggleAll(8)" />
                        <span></span>
                        <b>전체</b>
                    </label>
                    <label class="chk" v-for="item in options.aiState">
                        <input type="checkbox" v-model="select.aiState" :value="item.idx" />
                        <span></span>
                        <b>{{ item.name }}</b>
                    </label>
                </div>
            </li>
            <li v-if="props.gubun">
                <span class="bo_sch_tit">구분</span>
                <div class="bo_sch_content">
                    <div class="sch_box">
                        <select class="select gubun" v-model.number="select.gubun">
                            <option :value="0">전체</option>
                            <template v-for="item in options.gubun">
                                <option :value="item.idx">
                                    {{ item.name }}
                                </option>
                            </template>
                        </select>
                    </div>
                </div>
            </li>
            <li v-if="props.industry">
                <span class="bo_sch_tit">업종</span>
                <div class="bo_sch_content">
                    <div class="sch_box">
                        <select class="select industry" v-model.number="select.industry">
                            <option :value="0">전체</option>
                            <template v-for="item in options.industry">
                                <option :value="item.idx">
                                    {{ item.name }}
                                </option>
                            </template>
                        </select>
                    </div>
                </div>
            </li>
            <li v-if="props.dateRange">
                <span class="bo_sch_tit">기간</span>
                <div class="bo_sch_content">
                    <DateRange :date="select.date" @changeDate="selectDate"></DateRange>
                </div>
            </li>
            <li v-if="props.search">
                <span class="bo_sch_tit">검색어</span>
                <div class="bo_sch_content">
                    <div class="sch_box">
                        <select class="select" v-model.number="select.searchType" :disabled="props.selectOption.length < 2">
                            <template v-for="item in selectOption">
                                <option :key="item.idx" v-if="!item.clfCd || item.clfCd === author.clfCd" :value="item.idx">
                                    {{ item.text }}
                                </option>
                            </template>
                        </select>
                        <div class="sch_input_box">
                            <input
                                type="text"
                                placeholder="검색어를 입력하세요."
                                v-model="select.searchContent"
                                @keydown.enter="filterSave()"
                            />
                        </div>
                        <div class="sch_btns">
                            <button type="button" class="sch_btn" @click="filterSave()">검색하기</button>
                            <button type="button" class="sch_re_btn" @click="resetFilter()">
                                <img src="@/assets/board/re_btn.png" alt="" />
                                초기화
                            </button>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script lang="ts" config>
    import {
        apiService,
        onMounted,
        reactive,
        returnCode,
        DateRange,
        userStore,
        globalStore,
        inject,
        watch,
        searchFilter,
    } from "@/BaseComponent";
    interface FilterItem {
        idx: number;
        name: string;
    }

    export default {
        props: {
            sns: { type: Boolean, default: true },
            type: { type: Boolean, default: true },
            searchType: { type: Boolean, default: true },
            resultType: { type: Boolean, default: true },
            resultDetailType: { type: Boolean, default: true },
            nation: { type: Boolean, default: true },
            dateRange: { type: Boolean, default: true },
            searchContent: { type: Boolean, default: true },
            isMonitoring: { type: Boolean, default: true },
            platform: { type: Boolean, default: false },
            aiState: { type: Boolean, default: false },
            selectOption: { type: Array<any>, default: [] },
            search: { type: Boolean, default: true },
            gubun: { type: Boolean, default: false },
            industry: { type: Boolean, default: false },
        },
        components: {
            DateRange,
        },
        emits: ["search", "reset"],
        setup(props: any, { emit }: any) {
            const author = inject("author") as any;
            const { changeCode } = returnCode();
            const user = userStore();
            const global = globalStore();

            const state = reactive({
                allSns: false as boolean,
                allType: false as boolean,
                allResultType: false as boolean,
                allDetailType: false as boolean,
                allNation: false as boolean,
                allIsMonitoring: false as boolean,
                allPlatform: false as boolean,
                allAiState: false as boolean,
                allGubun: false as boolean,
                allIndustry: false as boolean,
            });

            const options = reactive({
                sns: [
                    { idx: 1, name: "X" },
                    { idx: 6, name: "블루스카이" },
                    { idx: 2, name: "구글" },
                    { idx: 3, name: "네이버" },
                    { idx: 4, name: "유튜브" },
                    { idx: 5, name: "인스타그램" },
                ] as FilterItem[],
                platform: [
                    { idx: 1, name: "Telegram" },
                    { idx: 2, name: "Discord" },
                    { idx: 4, name: "KakaoTalk" },
                    { idx: 3, name: "기타" },
                ] as FilterItem[],
                type: [
                    { idx: 1, name: "키워드" },
                    { idx: 2, name: "이미지" },
                    { idx: 3, name: "이미지+키워드" },
                ] as FilterItem[],
                aiState: [
                    { idx: 1, name: "판단" },
                    { idx: 0, name: "일반" },
                ] as FilterItem[],
                resultType: [] as FilterItem[],
                resultDetailType: [] as FilterItem[],
                nation: [] as FilterItem[],
                gubun: [
                    { idx: 0, name: "전체" },
                    { idx: 1, name: "성매매 업소 광고 대행" },
                    { idx: 2, name: "성매매 업소 예약관리 및 광고" },
                    { idx: 3, name: "성매매 업소 광고 알림" },
                    { idx: 4, name: "성매매알선포털사이트 주소 알림" },
                    { idx: 5, name: "성매수 후기 공유" },
                    { idx: 6, name: "성매매 관련 커뮤니티" },
                    { idx: 7, name: "성적 대상화 콘텐츠 공유" },
                    { idx: 8, name: "성적 대화 공유" },
                    { idx: 9, name: "기타 커뮤니티" },
                ] as FilterItem[],
                industry: [
                    { idx: 0, name: "전체" },
                    { idx: 1, name: "마사지" },
                    { idx: 2, name: "오피" },
                    { idx: 3, name: "유흥주점" },
                    { idx: 4, name: "키스방" },
                    { idx: 5, name: "출장마사지 알선 사이트" },
                    { idx: 6, name: "휴게텔" },
                    { idx: 7, name: "해외 성매매 알선" },
                    { idx: 8, name: "성매매알선포털사이트" },
                    { idx: 9, name: "성매수자 커뮤니티" },
                    { idx: 10, name: "기타" },
                    { idx: 11, name: "해당없음" },
                ] as FilterItem[],
                isMonitoring: [
                    { idx: 1, name: "유" },
                    { idx: 2, name: "무" },
                ] as FilterItem[],
            });

            const select = reactive({
                sns: [] as number[],
                type: [] as number[],
                resultType: [] as number[],
                resultDetailType: [] as number[],
                nation: [] as number[],
                isMonitoring: [] as number[],
                aiState: [] as number[],
                platform: [] as number[],
                gubun: 0 as number,
                industry: 0 as number,
                date: [] as Date[],
                searchType: 1 as number,
                searchContent: "" as string,
            });

            const resetFilter = () => {
                initFilter();
                const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                const endDate = new Date();
                select.date = [startDate, endDate];
                emit("reset", select);
            };

            const initFilter = () => {
                select.sns = options.sns.map((item) => item.idx);
                select.type = options.type.map((item) => item.idx);
                select.resultType = options.resultType.map((item) => item.idx);
                select.resultDetailType = options.resultDetailType.map((item) => item.idx);
                select.nation = options.nation.map((item) => item.idx);
                select.isMonitoring = options.isMonitoring.map((item) => item.idx);
                select.aiState = options.aiState.map((item) => item.idx);
                select.platform = options.platform.map((item) => item.idx);
                select.gubun = 0;
                select.industry = 0;
                select.date = global.searchDate;
                select.searchType = props.selectOption[0] ? props.selectOption[0].idx : 1;
                select.searchContent = "";
            };

            onMounted(() => {
                global.type.length !== 0 ? (options.resultType = global.type.filter((r: any) => r.idx < 2)) : getTypeList();
                global.detailType.length !== 0 ? (options.resultDetailType = global.detailType) : getDetailTypeList();
                global.nationList.length !== 0 ? (options.nation = global.nationList) : getNationList();
                global.gubun.length !== 0 ? (options.gubun = global.gubun) : getGubun();
                global.industry.length !== 0 ? (options.industry = global.industry) : getIndustry();
                if (global.searchDate.length > 0) select.date = global.searchDate;
                else {
                    const startDate = new Date(new Date().setDate(new Date().getDate() - 7));
                    const endDate = new Date();
                    select.date = [startDate, endDate];
                    global.setSearchDate([startDate, endDate]);
                }
                initFilter();
                emit("search", formatData());
            });

            watch(
                () => global.searchDate,
                (newDate) => {
                    select.date = newDate;
                },
            );

            watch(
                () => select.sns,
                (newVal) => {
                    state.allSns = newVal.length === options.sns.length;
                },
            );

            watch(
                () => select.type,
                (newVal) => {
                    state.allType = newVal.length === options.type.length;
                },
            );

            watch(
                () => select.platform,
                (newVal) => {
                    state.allPlatform = newVal.length === options.platform.length;
                },
            );

            watch(
                () => select.resultType,
                (newVal) => {
                    state.allResultType = newVal.length === options.resultType.length;
                },
            );
            watch(
                () => select.resultDetailType,
                (newVal) => {
                    state.allDetailType = newVal.length === options.resultDetailType.length;
                },
            );
            watch(
                () => select.nation,
                (newVal) => {
                    state.allNation = newVal.length === options.nation.length;
                },
            );
            watch(
                () => select.isMonitoring,
                (newVal) => {
                    state.allIsMonitoring = newVal.length === options.isMonitoring.length;
                },
            );
            watch(
                () => select.aiState,
                (newVal) => {
                    state.allAiState = newVal.length === options.aiState.length;
                },
            );

            const getTypeList = async () => {
                const res = await apiService.base.getTypeList();
                if (res.returnCode === 0) {
                    options.resultType = res.list.filter((r: any) => r.idx < 2);
                    global.setType(res.list);
                } else {
                    changeCode(res.returnCode);
                }
            };
            const getDetailTypeList = async () => {
                const res = await apiService.base.getDetailTypeList();
                if (res.returnCode === 0) {
                    options.resultDetailType = res.list;
                    global.setDetailType(res.list);
                } else {
                    changeCode(res.returnCode);
                }
            };
            const getNationList = async () => {
                const res = await apiService.base.getNationList();
                if (res.returnCode === 0) {
                    options.nation = res.list;
                    global.setNationList(res.list);
                } else {
                    changeCode(res.returnCode);
                }
            };
            const getGubun = async () => {
                const res = await apiService.ai.getTypeList(1);
                if (res.returnCode === 0) {
                    options.gubun = res.list;
                    global.setGubun(res.list);
                }
            };
            const getIndustry = async () => {
                const res = await apiService.ai.getTypeList(2);
                if (res.returnCode === 0) {
                    options.industry = res.list;
                    global.setIndustry(res.list);
                }
            };

            const filterSave = () => {
                emit("search", formatData());
            };

            const selectDate = (date: any) => {
                select.date = date;
                global.setSearchDate(date);
            };

            const formatData = () => {
                if (props.isMonitoring) {
                    let data = {} as searchFilter;
                    data.sns = select.sns;
                    data.type = select.type;
                    data.resultType = select.resultType;
                    data.resultDetailType = select.resultDetailType;
                    data.nation = select.nation;
                    data.isMonitoring = select.isMonitoring.length === options.isMonitoring.length ? null : select.isMonitoring[0];
                    data.platform = select.platform;
                    data.searchType = select.searchType;
                    data.date = select.date;
                    data.searchContent = select.searchContent;

                    return data;
                } else if (props.aiState) {
                    let data = {} as searchFilter;
                    data.aiState = select.aiState.length === options.aiState.length ? null : select.aiState[0];

                    data.searchType = select.searchType;
                    data.searchContent = select.searchContent;
                    data.date = select.date;
                    return data;
                } else {
                    return select;
                }
            };

            const toggleAll = (idx: number) => {
                switch (idx) {
                    case 1:
                        if (state.allSns) select.sns = options.sns.map((item) => item.idx);
                        else select.sns = [];
                        break;
                    case 2:
                        if (state.allType) select.type = options.type.map((item) => item.idx);
                        else select.type = [];
                        break;
                    case 3:
                        if (state.allResultType) select.resultType = options.resultType.map((item) => item.idx);
                        else select.resultType = [];
                        break;
                    case 4:
                        if (state.allDetailType) select.resultDetailType = options.resultDetailType.map((item) => item.idx);
                        else select.resultDetailType = [];
                        break;
                    case 5:
                        if (state.allNation) select.nation = options.nation.map((item) => item.idx);
                        else select.nation = [];
                        break;
                    case 6:
                        if (state.allIsMonitoring) select.isMonitoring = options.isMonitoring.map((item) => item.idx);
                        else select.isMonitoring = [];
                        break;
                    case 7:
                        if (state.allPlatform) select.platform = options.platform.map((item) => item.idx);
                        else select.platform = [];
                        break;
                    case 8:
                        if (state.allAiState) select.aiState = options.aiState.map((item) => item.idx);
                        else select.aiState = [];
                        break;
                }
            };

            return {
                props,
                state,
                options,
                select,
                filterSave,
                resetFilter,
                selectDate,
                toggleAll,
                user,
                author,
            };
        },
    };
</script>

<style scoped>
    #board_layer .sch_box .select.gubun,
    #board_layer .sch_box .select.industry {
        min-height: 45px;
        width: auto;
        padding-right: 50px;
    }
</style>
